import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';

const t = withLocalePrefix('talent_matching.bulk_actions.advance');

type Props = {
  openModal: () => void;
  selectionsHelper: SelectionsHelper;
  loading: boolean;
  canAdvance: boolean;
};

const AdvanceButton = ({
  openModal,
  selectionsHelper,
  loading,
  canAdvance,
}: Props) => {
  const otherwiseDisbled =
    !selectionsHelper.sameHiringPlan() ||
    !selectionsHelper.fromStageName ||
    !selectionsHelper.toStageName;
  const isDisabled =
    loading || !canAdvance || selectionsHelper.noneSelected || otherwiseDisbled;

  const tooltipText = !canAdvance
    ? t('tooltip.cannot_advance')
    : selectionsHelper.noneSelected
    ? t('tooltip.none_selected')
    : otherwiseDisbled
    ? t('tooltip.default')
    : null;

  return (
    <Tooltip label={tooltipText} ariaLabel={tooltipText || ''}>
      <PrimaryButton
        onClick={openModal}
        disabled={isDisabled}
        loading={loading}
        size="md"
      >
        {t('button', { count: selectionsHelper.totalSelected })}
      </PrimaryButton>
    </Tooltip>
  );
};

export default AdvanceButton;
